import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ImageUtilService } from '../../shared/image-util-service/image-util.service';
import { ImageAsDataUrl } from '../../shared/image-util-service/image-as-data-url';
import { Subscription, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Component({
  selector: 'lp2-message-bubble',
  templateUrl: './message-bubble.component.html',
  styleUrls: ['./message-bubble.component.scss'],
})
export class MessageBubbleComponent implements OnInit, OnDestroy {
  @Input() name: string;
  @Input() date: number;
  @Input() text: string[];
  @Input() title: string;
  @Input() subTitle: string;
  @Input() isSenderDisplayed = true;
  @Input() sentByPersonUuid: string;
  @Input() isLeftStyle = true;

  avatar: ImageAsDataUrl = { image: null };
  avatarHeightWidth = 42;
  subscription: Subscription;
  loading = true;

  constructor(private readonly cdRef: ChangeDetectorRef, private imageUtilService: ImageUtilService) {}

  ngOnInit(): void {
    if (!this.isSenderDisplayed) {
      this.loading = false;
      return;
    }
    this.subscription = this.imageUtilService
      .getProfilePicByUuid(this.avatarHeightWidth, this.avatarHeightWidth, this.sentByPersonUuid)
      .pipe(catchError(() => of(null)))
      .subscribe((imageUrl) => {
        this.avatar.image = imageUrl;
        this.loading = false;
        this.cdRef.detectChanges();
      });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./ts/app/teacher-feedback/message-bubble/message-bubble.component.ts